import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { IGoogleAuthWarningStorageService } from '@app/models/objects/google-auth-warning-storage.model';

const COOKIE_KEY = '2faAuthWarning';
const COOKIE_EXPIRE_DAYS = 15;

@Injectable({ providedIn: 'root' })
export class CookieGoogleAuthWarningStorageService implements IGoogleAuthWarningStorageService {
  constructor(private cookieService: CookieService) {}

  check(): boolean {
    return this.cookieService.check(COOKIE_KEY);
  }

  set(): void {
    this.cookieService.set(COOKIE_KEY, '1', COOKIE_EXPIRE_DAYS, '/');
  }

  delete(): void {
    this.cookieService.delete(COOKIE_KEY, '/');
  }
}
